import { Text } from '@mantine/core'
import { Viewer, Worker } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { FullScreenPdfDisplayProps } from '../../../../types/preview'
import ErrorReplace from '../../../ErrorReplace'
import LoaderReplace from '../../../LoaderReplace'
import useBase64Conversion from '../../../useBase64Conversion'
import { PDF_VIEWER_LOCALIZATION } from '../Localization'

const FullscreenDisplay = ({
  asset,
  maxWidth,
}: FullScreenPdfDisplayProps): React.ReactElement => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin()

  const { blobDownloading, blobUrl, invalidBlobUrl } = useBase64Conversion({
    asset,
  })

  const { t } = useTranslation(['file_uploads', 'pdf'])

  if (blobDownloading) {
    return <LoaderReplace />
  }

  if (!asset.public_url && invalidBlobUrl) {
    return (
      <>
        <Text>no public_url or invalidBlobUrl</Text>
        <ErrorReplace
          asset={asset}
          maxWidth={maxWidth}
          error={t('file_uploads:preview.corrupt_pdf')}
        />
      </>
    )
  }

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.4.456/build/pdf.worker.js">
      <div style={{ height: '90vh' }}>
        <Viewer
          fileUrl={asset.public_url ?? (blobUrl || '')}
          plugins={[defaultLayoutPluginInstance]}
          localization={PDF_VIEWER_LOCALIZATION}
          renderError={(error) => (
            <div>
              {error.message}
              {error.name}
              <ErrorReplace
                asset={asset}
                maxWidth={maxWidth}
                error={t('file_uploads:preview.corrupt_pdf')}
              />
            </div>
          )}
          renderLoader={(_percentages) => <LoaderReplace />}
        />
      </div>
    </Worker>
  )
}

export default FullscreenDisplay
